module.exports = __webpack_public_path__ + "img/ultra_1_01.a35230af.jpg";